export function stringInject(str, data) {
    let objValue = null;
    for (let key in data) {
        let newKey = transformKey(key);
        let reg = new RegExp(newKey, 'g');
        str = str.replace(reg, (i) => {
            if(typeof data[i] === 'object'){
                objValue = data[i];
                return
            }
            if (data[i] === null || data[i] === undefined) {
                return ''
            }
            return data[i]
        });
    }
    return objValue ? objValue : str
}

function transformKey(key) {
    // eslint-disable-next-line no-useless-escape
    try {
        let newReg = new RegExp(/[\(]|[\)]|[\$]|[\*]|[\[]|[\]]|[\+]|[\?]|[\.]|[\||]/, 'g');
        return key.replace(newReg, (i) => {
            return `\\${i}`
        })
    } catch (e) {
        console.log(e);
        return ''
    }
}